export const WEB_LINK = 'web-link';
export const ANCHOR_LINK = 'anchor-link';
